



































































































































































































































































































































































import _, { toNumber } from 'lodash';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit, openList } from '@/main/router/routerPath';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { cancelButton, createButton } from '@/main/utils/tableOperations';
import { Cell, cellNames, Column, Table, getColumnsRowMapObject, convertToObjects, Row, EditableStatus } from '@/main/utils/table';
import { START_LOADING, END_LOADING } from '@/main/store/listEditTypes';
import { mapActionsDvm } from '@/main/pages';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { showAlert } from '@/main/utils/notifications';
import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';
import { UserRole, VehicleBrand, ScreenSize, HideColumns } from '@/main/components/constants';
import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import { apiProvider } from './api';
import { ZAKAZKA_DRUH, ZAKAZKA_STAV, ZAKAZKA_ND, JOB_STATUS} from '../constants';
import { getStavZakazka } from '../utils';
import { NAME, LINE_ITEM_STATUS_REASON, SPLIT_BILLING, PARTS, PART_COLS, MAX_DISCOUNT_LIMIT, MIN_DISCOUNT_LIMIT, MIN_FIELD_LEVEL,MAX_SHARE_PERCENTAGE, BULK_UPLOAD, ROW_SAVED, ROW_EDIT_CLICKED } from './constants';
import { store } from '../store/edit';
import {SPLIT_PARTIES} from '../ServiceJobSplitBilling/constants';
import { DropdownItem, WorkersWithCostCenter } from '@/main/store/@types/dropdown.d';
export default EditStoreMixin.extend({
	name: 'NahradniDilyCard',
	components: {
		DmsPdfDialog,
		DmsEditableTable,
	},
	props: {
		storeUri: { type: String, default: null, required: true },

	},
	data() {
		return {
			cancelPRDialog: {
				label: this.LocalizeChyboveHlasky('Cancel_Process'),
				message: null as string | null,
				visible: false,
			},
			descriptionInput: '',
			noteInput: '',
			rowData: {},
			ZAKAZKA_STAV,
			ZAKAZKA_DRUH,
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			showTiskDialog: false,
			zakazkaNdPohybDoklId: [],
			applyAdditionalDiscount: false,
			showCancelOrderDialog: false,
			showSplitSharesPartsDialog: false,
			rowDataId: 0,
			showDiscountSection: false,
			dialogHeaderText: '',
			splitShareDialogHeaderText: 'Split Share Details',
			multipleSelection: [],
			showMarkComplete: false,
			showDeleteButton: false,
			showPartsDialog: false,
			showPartsDialogInternal: true,
			partsDialogKey: 0,
			fileList: [] as any[],
			splitShareTable: [],
			tableKey: '0',
			splitShareTableloading: true,
			isJobStatusPending: false,
			isPendingStatusOther: false,
			isServiceJobEditable: true,
			isElementEditable: true,
			lineItemPendingReasonId: 0,
			lineItemPendingRemarks: '',
			totalDiscount: 0,
			partCols: PART_COLS,
			isDiscountEditable: true,
			isRrpPriceEditable: true,
			rrpUnitPriceInput: '',
			cancelRrpunitPriceInput: '',
			warrantyPriceInput: '',
			cancelWarrantyPriceInput: '',
			cancelDiscountAmountInput: '',
			cancelDiscountPercentInput: '',
			discountAmountReverted: false,
			canEditWarrantyPrice: false,
			localCostCenter: null as number | null,
			localLaborPrice: null as number | null		
		};
	},
	mounted() {
		this.refreshTable(ZAKAZKA_ND);
	},
	computed: {
		isUserPartsManagerOrAdmin(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		isWorkCompleteVisible(): boolean {
			return (this.showMarkComplete && !this.isSalesCounterOrder && (!this.tableDisabled || this.canEditTableInReleaseMode)
			&& (this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.SERVICE_ADVISER || this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.ADMIN
			|| this.loggedUser.PracovnikData.PracovnikOzn!.toUpperCase() === UserRole.PARTS_MANAGER));
		},
		getWidth() :string {
			return this.windowWidth <= this.screenSize ? ScreenSize.DIALOG_TABLET_WIDTH : ScreenSize.DIALOG_DEFAULT_WIDTH;
		},
		isSalesCounterOrder(): boolean {
			return this.ZakazkaDruh! === ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		isPartPlusVisible(): boolean {
			return this.ZakazkaDruh! === ZAKAZKA_DRUH.PREVOD_ND || this.NabidkaPrp!;
		},
		extraButtons(): {} {
			if (this.edit.Stav === ZAKAZKA_STAV.UVOLNENA) {
				return { ...cancelButton(this.cancelPartsClick)	};
			}
			return { ...createButton(this.partDiscount) };
		},
		...genVuexComputeds(store),
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		nahradniDilyTable(): any {
			let idColumn: number;
			_.forEach(this.dependentTables.ZakazkaNd.columns, (col) => {
				if (col.columnName === 'BILL_TO') {
					col.iconClass = 'el-icon-info';
				}
				if (col.columnName.toUpperCase() === HideColumns.STAV) {
					col.isVisible = false;
				}
				if (col?.columnId !== null) { idColumn = toNumber(col?.columnId); } else {
					col.columnId = (idColumn + 1).toString();
					idColumn = toNumber(col.columnId);
				}
			});
			let count = 0;
			_.map(this.dependentTables.ZakazkaNd.rows, () => {
				const NdNRIndex = this.dependentTables.ZakazkaNd.cellNames!.IS_ADDITIONAL;
				const IsAddtional = this.dependentTables.ZakazkaNd.rows[count].cells[NdNRIndex];
				if (IsAddtional) {
					this.IsApprovalDropDownVisible = false;
					return this.dependentTables.ZakazkaNd;
				}
				count += 1;
				return this.dependentTables.ZakazkaNd;
			});
			return this.dependentTables.ZakazkaNd;
		},
		isUserPartsManager(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.PARTS_MANAGER) && this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND;
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0 && this.zakazkaStav !== ZAKAZKA_STAV.V_PRIPRAVE;
		},
		zakazkaNd(): string {
			return NAME;
		},
		tableDisabled(): boolean {
			if (this.edit.UvolneniDat !== null && this.edit.UzavreniDat === null && this.edit.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT) {
				this.isReleasedOrder = true;
			}
			return this.isViewMode || this.isReleasedOrder || this.isZpracuj || (this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND && this.isZakazkaDisabled);
		},
		isSplitBillingAvailableForOrderType(): boolean {
  	 	 if ((this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND) && (this.VozidloId === null)) {
       		 return false;
  		  }
	    if (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) {
     	   return this.VozidloId != null;
   		 }
  		  return true;
		},
		canEditTableInReleaseMode(): boolean {
			return ((this.isSplitBillingAvailableForOrderType && this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA) || (this.isSalesCounterOrder && this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA)
		 || (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.VozidloId === null));
		},
		shouldShowPartsDialog(): boolean {
			return this.showPartsDialog;
		},
	},
	watch: {
		nahradniDilyTable(table: Table) {
			const pcSlevaPoId = cellNames(table).PC_SLEVA_PO;
			if (!pcSlevaPoId) {
				return;
			}
			const cenaCelkemReducer = (cenaCelkem: number, radek: any) => cenaCelkem + radek.cells[pcSlevaPoId];
		},
	},
	methods: {
		onHyperLinkClick({ row } : { row : Row }) {
			OpenPartMaintenance({ cellNames: this.nahradniDilyTable.cellNames, row });
		},
		updateRows({ rows }: { rows: Row[] }) {
			this.dependentTables.ZakazkaNd.rows = rows;
		},
		updateRow(rowUpdateData: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row }) {
			const partNumberId: number = this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID;
			const row: Row = this.nahradniDilyTable.rows.find((item: Row) => item.cells[partNumberId] === rowUpdateData.rowId);
			if (rowUpdateData.updateStatus === EditableStatus.DELETED) {
				const servicePackageColId: number = this.dependentTables.ZakazkaNd.cellNames!.SERVICE_PACKAGE_ID;
				const DefaultLineItemStatusIndex: number = this.nahradniDilyTable.cellNames!.LINE_ITEM_STATUS_ID;
				if (row.cells[servicePackageColId] !== null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				if (this.dmsSys.IsActivityEndTimePrp && row.cells[DefaultLineItemStatusIndex] === JOB_STATUS.COMPLETED) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
			}
			this.$store.commit(`${this.storeUri}/updateTableRow`, rowUpdateData);
		},
		async onRrpUnitPriceChange(value: any, row: Row, columnId: number, updateCol: any) {				
			updateCol(value, columnId);				
			row.cells[columnId] = value;
		},
		async onRrpUnitPriceLeave(value: any, row: Row, columnId: number, updateCol: any) {
			if (value <= 0 || value === null) {				
					this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCorrectUnitPrice'),
					options: { type: 'error' },
					localizeMessage: false,
				});
					updateCol(this.rrpUnitPriceInput, columnId);
					row.cells[columnId] = this.rrpUnitPriceInput;				
					return false;
			}
			updateCol(value, columnId);	
			this.rrpUnitPriceInput = value;				
			row.cells[columnId] = value;
		},
		async onWarrantyPriceChange(value: any, row: Row, columnId: number, updateCol: any) {
			updateCol(value, columnId);
			row.cells[columnId] = value;
		},
		async onWarrantyPriceLeave(value: any, row: Row, columnId: number, updateCol: any) {
			if (value === null || value < 0) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('invalidWarrantyPrice'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				updateCol(this.warrantyPriceInput, columnId);
				row.cells[columnId] = this.warrantyPriceInput;
				return false;
			}
			updateCol(value, columnId);
			this.warrantyPriceInput = value;
			row.cells[columnId] = value;
			return true;
		},

		async onEditRow({ rowIndex, row }: { rowIndex: number, row: Row }) {
			const DefaultLineItemStatusIndex: number = this.nahradniDilyTable.cellNames!.LINE_ITEM_STATUS_ID;
			const DefaultLineItemPendingReasonIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REASON_ID;
			const DefaultLineItemPendingRemarksIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REMARKS_OTHERS;
			const IsLockedIndex: number = this.nahradniDilyTable.cellNames!.IS_LOCKED;
			const ServicePackageIndex: number = this.nahradniDilyTable.cellNames!.SERVICE_PACKAGE_ID;
			const partNumberColId: number = this.nahradniDilyTable.cellNames!.ZAZNAM_ID;
			const rrpUnitPriceColId: number = this.nahradniDilyTable.cellNames!.RRP_UNIT_PRICE;
			const warrantyPriceColId: number = this.nahradniDilyTable.cellNames!.WARRANTY_PRICE;
			const itemId = row.cells[partNumberColId];			

			this.lineItemPendingReasonId = row.cells[DefaultLineItemPendingReasonIndex];
			this.lineItemPendingRemarks = row.cells[DefaultLineItemPendingRemarksIndex];
			this.rrpUnitPriceInput = row.cells[rrpUnitPriceColId];
			this.cancelRrpunitPriceInput = row.cells[rrpUnitPriceColId];
			this.warrantyPriceInput = row.cells[warrantyPriceColId];
			this.cancelWarrantyPriceInput = row.cells[warrantyPriceColId];
			const discountAmountColId: number = this.nahradniDilyTable.cellNames!.DISCOUNT_VAL;
			this.cancelDiscountAmountInput = row.cells[discountAmountColId];
			const discountPercentColId: number = this.nahradniDilyTable.cellNames!.DISCOUNT_PERCENT;
			this.cancelDiscountPercentInput = row.cells[discountPercentColId];
			this.discountAmountReverted = false;

			this.isServiceJobEditable = true;
			this.isElementEditable = true;
			this.isDiscountEditable = true;
			this.isRrpPriceEditable=true;
			this.canEditWarrantyPrice = true;
			
			if(await this.isWarrantyOrGoodwillSplitExists(row))
			{				
				this.isDiscountEditable = false;
				this.isRrpPriceEditable = false;
			}

			if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND)
			{
				this.canEditWarrantyPrice = false;
			}

			if (row.cells[DefaultLineItemStatusIndex] === JOB_STATUS.PENDING) {
				this.isJobStatusPending = true;
			} else {
				this.isJobStatusPending = false;
				this.isPendingStatusOther = false;
			}
			if (row.cells[DefaultLineItemPendingReasonIndex] === JOB_STATUS.PENDING_OTHER) {
				this.isPendingStatusOther = true;
			} else {
				this.isPendingStatusOther = false;
			}
			
			let ispartInvoiced = await this.isAnyPartInvoiced(this.ZakazkaId, itemId, 'PARTS');
			this.isDiscountEditable = ispartInvoiced ? false:true;
			this.isRrpPriceEditable= ispartInvoiced ? false:true;
			this.canEditWarrantyPrice= ispartInvoiced ? false:true;

			//US#7543 Don't edit line item if it contains Goodwill or Warranty splits and Order is in released state.
			if( this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && this.IsOrderSentToSaga === true && await this.isSagaSplitPartyExists(itemId))
			{
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isServiceJobEditable = false;
				this.isElementEditable = false;
				this.isRrpPriceEditable = false;
				return;
			}

			if (row.cells[IsLockedIndex] && this.dmsSys.IsCancelInvoicePrp) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemIsLocked'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isServiceJobEditable = false;
				this.isElementEditable = false;
				this.isDiscountEditable = false;
				this.isRrpPriceEditable=false;
				this.canEditWarrantyPrice = false;
				return;
			}
			if (row.cells[ServicePackageIndex] !== null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isServiceJobEditable = false;
				this.isElementEditable = false;
				this.isDiscountEditable = false;
				this.isRrpPriceEditable=false;
				this.canEditWarrantyPrice = false;
				return;
			}

			if (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && !ispartInvoiced)
			{
				 this.isServiceJobEditable = true;
				 this.isElementEditable = true;
				 this.isDiscountEditable = true;
				 this.isRrpPriceEditable=true;
				this.canEditWarrantyPrice = true;
				return;
			}

			if (this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA || this.zakazkaStav === ZAKAZKA_STAV.NABIDKA || this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND)
			{
				this.canEditWarrantyPrice = false;
			}

			if (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && ispartInvoiced) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				this.isServiceJobEditable = false;
				this.isElementEditable = false;
				this.isRrpPriceEditable = false;
				return;
			}
		},

		 async isAnyPartInvoiced(orderId: number, itemId: number, itemType: string) {
			const { data: isInvoiced } = await apiProvider.isPartOrLabourInvoiced(orderId, itemId, itemType);
			return isInvoiced;
			
		 },
		async isSagaSplitPartyExists(itemId: number) {
			try{
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const response = await apiProvider.getSplitDetails(itemId, this.ZakazkaId!);
				const checkPartyType = (object:any) => (object.PartyType === SPLIT_PARTIES.Goodwill || object.PartyType === SPLIT_PARTIES.Warranty);
				const result=response?.data?.some(checkPartyType);
				return result;
			}
			finally{
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},

		calculateTotalDiscount(row: Row) : number {
			const lineItemDiscountColId = this.dependentTables.ZakazkaNd.cellNames?.DISCOUNT_PERCENT;
			const campaignDiscountColId = this.dependentTables.ZakazkaNd.cellNames?.CAMPAIGN_DISCOUNT_PERCENT;
			const lineItemDiscountValue: number = parseFloat(row.cells[lineItemDiscountColId as number] || 0);
			const campaignDiscountValue: number = parseFloat(row.cells[campaignDiscountColId as number] || 0);
			this.totalDiscount = lineItemDiscountValue + campaignDiscountValue;
			return this.totalDiscount;
		},
		// calculateDiscountValue(row: Row) {
		// 	const spDiscountedIndex = this.dependentTables.ZakazkaNd.cellNames?.PC_SLEVA_PO;
		// 	const priceBeforeDiscountIndex = this.dependentTables.ZakazkaNd.cellNames?.PC_CEL_SL_PRED;
		// 	const totalDiscount: number = this.calculateTotalDiscount(row);
		// 	const calculateDiscountAmount: number = row.cells[priceBeforeDiscountIndex as number] * (totalDiscount / 100);
		// 	row.cells[spDiscountedIndex as number] = +(row.cells[priceBeforeDiscountIndex as number] - calculateDiscountAmount).toFixed(2);
		// },
		async rowSaved({ row: newRow }: { row: Row }) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const RrpUnitIndex: number = this.nahradniDilyTable.cellNames?.RRP_UNIT_PRICE;
				const newRrpUnitValue = newRow.cells[RrpUnitIndex];
						if (newRrpUnitValue <= 0 || newRrpUnitValue === null) {					
						this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('msgCorrectUnitPrice'),
						options: { type: 'error' },
						localizeMessage: false,
					});
						newRow.cells[RrpUnitIndex] = this.rrpUnitPriceInput;			
						return false;
				}
				const serviceJobColIndex: number = this.nahradniDilyTable.cellNames!.SERVICE_JOB_ID!;
				const newServiceJobId = newRow.cells[serviceJobColIndex];
				if(newServiceJobId! > 0 && await this.isWarrantyOrGoodwillExistInServiceJobSplit(newServiceJobId)){
					showAlert({
							message: this.LocalizeChyboveHlasky('Zero_Discount_Warning_Msg'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: {
								type: 'info',
							},
						});
						let discountColId = this.nahradniDilyTable.cellNames?.DISCOUNT_PERCENT;
						newRow.cells[discountColId as number]=0;
				}
				//this.calculateDiscountValue(newRow);
				const DefaultLineItemStatusIndex: number = this.nahradniDilyTable.cellNames?.LINE_ITEM_STATUS_ID;
				const DefaultLineItemPendingReasonIndex: number = this.nahradniDilyTable.cellNames?.PENDING_REASON_ID;
				const DefaultLineItemPendingRemarksIndex: number = this.nahradniDilyTable.cellNames?.PENDING_REMARKS_OTHERS;
				const WarrantyPriceIndex: number = this.nahradniDilyTable.cellNames?.WARRANTY_PRICE ?? 0;
				const newWarrantyPriceValue = newRow.cells[WarrantyPriceIndex];
				if (newWarrantyPriceValue <= 0 || newWarrantyPriceValue === null) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('invalidWarrantyPrice'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					newRow.cells[WarrantyPriceIndex] = this.warrantyPriceInput;
					return false;
				}

				if (newRow.cells[DefaultLineItemStatusIndex] != JOB_STATUS.PENDING) {
					newRow.cells[DefaultLineItemPendingReasonIndex] = 0;
					newRow.cells[DefaultLineItemPendingRemarksIndex] = '';
				}
				if (newRow.cells[DefaultLineItemPendingReasonIndex] != JOB_STATUS.PENDING_OTHER) {
					newRow.cells[DefaultLineItemPendingRemarksIndex] = '';
				}
				const DiscPerIndex: number = this.nahradniDilyTable.cellNames?.DISCOUNT_PERCENT;
				if (
					newRow.cells[DiscPerIndex]! < MIN_DISCOUNT_LIMIT
					|| newRow.cells[DiscPerIndex]! > MAX_DISCOUNT_LIMIT
				) {
					newRow.cells[DiscPerIndex] = MIN_FIELD_LEVEL;
					this.showErrorAlert({
						// Using Predefined message
						message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					return false;
				}
				const itemIdColId: number = this.nahradniDilyTable.cellNames!.ZAZNAM_ID;
				const discountAmountColId: number = this.nahradniDilyTable.cellNames!.DISCOUNT_VAL;
				const itemId: number = +(newRow.cells[itemIdColId] ?? 0);
				const discountAmount: number = +(newRow.cells[discountAmountColId] ?? 0);
				if (itemId > 0 && discountAmount > 0) {
					const campaignDiscountColId: number = this.nahradniDilyTable.cellNames!.CAMPAIGN_DISCOUNT_PERCENT;
					const billToColId: number = this.nahradniDilyTable.cellNames!.BILL_TO;
					const validationResponse = await zakazkaApiProvider.ValidateGrossDiscountAmountForIssuedPartSplitParties(
						this.ZakazkaId!,
						itemId,
						PARTS,
						newRow.cells[discountAmountColId] ?? 0,
						this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0,
						newServiceJobId,
						newRow.cells[RrpUnitIndex],
						newRow.cells[campaignDiscountColId] ?? null,
						newRow.cells[billToColId] ?? null,
					);
					const validationMessage: string = validationResponse?.data;
					if (validationMessage) {
						var message = this.LocalizeChyboveHlasky(validationMessage).replace('<BRAND_DISCOUNT>', newRow.cells[campaignDiscountColId] ?? 0);
						this.showErrorAlert({
							message: message,
							options: { type: 'error' },
							localizeMessage: false,
						});
						// Revert to the original value only on the first validation failure, keep user input on subsequent failures
						if (!this.discountAmountReverted) {
							newRow.cells[discountAmountColId] = this.cancelDiscountAmountInput;
							newRow.cells[DiscPerIndex] = this.cancelDiscountPercentInput;
							this.discountAmountReverted = true;
						} else {
							newRow.cells[discountAmountColId] = discountAmount;
						}
						this.$nextTick(() => {
							const editableTable: any = this.$refs.editableTable;
							const rowIndex = editableTable.editTableRows.indexOf(newRow);
							if (rowIndex >= 0) {
								editableTable.editRow(rowIndex, newRow);
							}
						});
						return false;
					}
				}
				return true;
			}
			finally {
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		
		},
		rowCancel(row: any) {
			if (row !== undefined && row.row !== undefined) {
				const DefaultLineItemPendingReasonIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REASON_ID;
				const DefaultLineItemPendingRemarksIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REMARKS_OTHERS;
				const rrpUnitPriceColId: number = this.nahradniDilyTable.cellNames!.RRP_UNIT_PRICE;
				const warrantyPriceColId: number = this.nahradniDilyTable.cellNames!.WARRANTY_PRICE;

				row.row.cells[DefaultLineItemPendingReasonIndex] = this.lineItemPendingReasonId;
				row.row.cells[DefaultLineItemPendingRemarksIndex] = this.lineItemPendingRemarks;

				this.rrpUnitPriceInput = this.cancelRrpunitPriceInput;
				row.row.cells[rrpUnitPriceColId] = this.cancelRrpunitPriceInput;

				this.warrantyPriceInput = this.cancelWarrantyPriceInput;
				row.row.cells[warrantyPriceColId] = this.cancelWarrantyPriceInput;
			}
		},
		onTextInput(event: any, row: Row, columnId: number) {
			this.descriptionInput = event;
			row.cells[columnId] = event;
		},
		onNoteInput(event: any, row: Row, columnId: number) {
			this.noteInput = event;
			row.cells[columnId] = event;
		},
		getServiceJobDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.ServiceJobForItems.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		getTechnicianDetails(row: Row, columnId: number) {
			if (this.edit.UzavreniDat !== null) {
				const technicianNameColId =	this.nahradniDilyTable.cellNames?.TECHNICIAN_NAME
				
				if (technicianNameColId !== undefined && technicianNameColId !== null) {
					const technicianName = row.cells[technicianNameColId];
					if (technicianName !== null && technicianName !== undefined && technicianName !== '') {
						return technicianName;
					}
				}

				return row.cells[columnId];
			}
			const result: any = this.dropdownList.TechiciansList.find(
			(item: any) => item.Value === parseInt(row.cells[columnId]),
		);
		return result?.Text;
},
		getLineItemStatusDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.LineItemStatuses.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		getLineItemStatusPendingReasonDetails(row: Row, columnId: number) {
			const result: any = this.dropdownList.StatusPendingReasons.find((item: any) => item.Value === row.cells[columnId]);
			return result?.Text;
		},
		onUpdateJobStatus(val: number | null, row: Row, columnId: number) {
			const DefaultLineItemPendingReasonIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REASON_ID;
			const DefaultLineItemPendingRemarksIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REMARKS_OTHERS;

			if (val === JOB_STATUS.PENDING) { this.isJobStatusPending = true; } else {
				row.cells[DefaultLineItemPendingReasonIndex] = 0;
				row.cells[DefaultLineItemPendingRemarksIndex] = '';
				this.isJobStatusPending = false;
				this.isPendingStatusOther = false;
			}
		},
		onUpdatePendingReason(val: number | null, row: Row, columnId: number) {
			const DefaultLineItemPendingRemarksIndex: number = this.nahradniDilyTable.cellNames!.PENDING_REMARKS_OTHERS;
			if (val === JOB_STATUS.PENDING_OTHER) {
				this.isPendingStatusOther = true;
			} else {
				row.cells[DefaultLineItemPendingRemarksIndex] = '';
				this.isPendingStatusOther = false;
			}
		},
		booleanIcon(row: Row, columnId: number): string {
			return row.cells[columnId] ? 'el-icon-check' : 'el-icon-close';
		},
		getLocalizedText(text: string) {
			return this.LocalizePopisPoli(text);
		},
		isPartyLevelDiscountEnabled(row: Row, columnId: number): boolean {
			const isPartyLevelDiscEnabledColId = this.nahradniDilyTable?.cellNames?.IS_PARTY_LEVEL_DISCOUNT_ENABLE;
			const discountColId = this.nahradniDilyTable?.cellNames?.DISCOUNT_PERCENT;
			if (isPartyLevelDiscEnabledColId === undefined || isPartyLevelDiscEnabledColId === null) {
				return false;
			}
			
			const discountValue = row.cells[discountColId];

			const isPartyLevelDiscEnabled = row.cells[isPartyLevelDiscEnabledColId];
			// Treat an explicitly entered 0 the same as any other entered discount value, don't mark it as MIXED
			if ((discountValue !== null && discountValue !== undefined && discountValue !== '' && !Number.isNaN(+discountValue))) {
				return false;
			} else if (isPartyLevelDiscEnabled === false){
				return false;
			} else {
				return true
			}
			//return false;
		},
		redirectToSplitBilling(): boolean {
			return (this.zakazkaStav !== ZAKAZKA_STAV.UZAVRENA && this.isEditMode);
		},
		onSplitSharesPartsDialogClosed() {
			this.splitShareTableloading = false;
		},
		async cellClick(row: any, column: any, cell: any) {
			const cols : number[] = [];
			const priceWithoutGstCol: Column[] = this.dependentTables.ZakazkaNd.columns.filter((item) => item.columnName === this.partCols.PC_WITHOUT_GST || item.columnName === this.partCols.PC_WITH_GST || item.columnName === this.partCols.PC_VC_DPH_NAD || item.columnName === this.partCols.PC_BEZ_DPH_NAD);
			priceWithoutGstCol.forEach(col => {
				cols.push(parseInt(col!.columns!.find((item) => item.columnName === this.partCols.PC_SLEVA_PO)!?.columnId));
			});
			const partNumberColId: number = this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID;
			const totalDiscount: number = this.calculateTotalDiscount(row);
			const quantityColId = this.dependentTables.ZakazkaNd.cellNames!.X_STAVVJ;
			const partColId = this.dependentTables.ZakazkaNd.cellNames!.ND_NR;
		
			if (this.isSplitBillingAvailableForOrderType) {
				if (this.redirectToSplitBilling() && cols.includes(column)) {
					const itemId = row.cells[partNumberColId];
					//US#7543 Don't allow splitting if it contains Goodwill or Warranty splits and Order is in released state.
					// if(this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && await this.isSagaSplitPartyExists(itemId)) {
					// 	return;
					// }
					openList(SPLIT_BILLING, {						
						filter: {
							ItemType: PARTS,
							ServiceOrderId: this.ZakazkaId,
							ItemId: itemId,
							Modified: totalDiscount,
							OrderStatus: this.zakazkaStav,
							PartNumber: row.cells[partColId],
							Quantity: row.cells[quantityColId],
							Saga2Prp: this.Saga2Prp,
							IsOrderSentToSaga: this.IsOrderSentToSaga,
						},
					}, { ServiceOrderId: this.ZakazkaId, ItemId: itemId, ItemType: PARTS, Modified: totalDiscount, OrderStatus:this.zakazkaStav,PartNumber: row.cells[partColId],Quantity:row.cells[quantityColId], Saga2Prp: this.Saga2Prp, IsOrderSentToSaga: this.IsOrderSentToSaga });
				} else if (column === this.dependentTables.ZakazkaNd.cellNames!.BILL_TO) {
					const itemId = row.cells[partNumberColId];
					this.splitShareTable = [];
					this.getSplitShareDetails(itemId);
					this.showSplitSharesPartsDialog = true;
				}
			}
		},
		decorateCells({ row, column }: { row: Row, column: any }) {
			if (this.isSplitBillingAvailableForOrderType) {
				if ((this.redirectToSplitBilling() && column.label === this.LocalizePopisPoli('PC_SLEVA_PO') && this.partCompletionStatusCheck(row))
					|| column.label === this.LocalizePopisPoli('BILL_TO')) {
					return { color: 'Blue', cursor: 'pointer', textDecoration: 'underline' };
				}
			}
		},
		async submitUpload() {
			const startTime = performance.now();
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			const { data: partsInfo } = await apiProvider.uploadParts(this.fileList[0], this.ZakazkaId, this.edit.Stav);
			this.onPartsDialogClose();
			if (partsInfo) {
				showAlert({
					message: partsInfo,
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
			}
			const endTime  = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, BULK_UPLOAD, seconds);
			if ((this as any).ZakazkaNdFilter) {
				(this as any).ZakazkaNdFilter.ZakazkaId = this.ZakazkaId;
			}
			await this.refreshTable(ZAKAZKA_ND);
            this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
		async showUploadPartsClick() {
			this.showPartsDialog = false;
			await this.$nextTick();
			this.partsDialogKey += 1;
			this.fileList = [];
			await this.$nextTick();
			this.showPartsDialog = true;
			this.$forceUpdate();
		},
		onPartsDialogClose() {
			console.log('onPartsDialogClose called');
			this.showPartsDialog = false;
			this.fileList = [];
			this.$nextTick();
		},
		handleChange(file: Record<string, any>) {
			this.fileList = [file];
		},
		handleRemove(file: File, fileList: []) {
			this.fileList = fileList;
		},
		cancelPartsClick(e: any, cells: any) {
			const data = getColumnsRowMapObject(this.dependentTables.ZakazkaNd.columns, cells);
			this.rowData = data;
			this.ZaznamId = data.ID;
			if (this.dmsSys.Parts_Order_Cancel_Prp) {
				this.CancellationReasonType = null;
				this.CancellationReason = null;
				this.cancelPRDialog.visible = true;
			}
		},
		async cancelRowClick() {
			if (_.isNil(this.CancellationReasonType)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('CancelReason'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			if (this.CancellationReasonType === LINE_ITEM_STATUS_REASON.CANCELLATION_REASON && this.CancellationReason === null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('CancelRemarks'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return;
			}
			this.cancelPRDialog.visible = false;
			const result = await this.CancelServicePackage();
			if (result) {
				const data = this.rowData;
				this.$emit('delete-click', { name: this.dependentTables.ZakazkaNd.name, data });
			}
		},
		...mapActionsDvm(store.actions),
		zakazkaNdListClick() {
			openList(NAME, { filter: { ZakazkaId: this.ZakazkaId } });
		},
		partDiscount(e: any, cells: any) {
			if (this.dmsSys.OrderDiscountPrp) {
				const data = getColumnsRowMapObject(this.dependentTables.ZakazkaNd.columns, cells);
				this.applyAdditionalDiscount = true;
				this.showCancelOrderDialog = true;
				this.rowDataId = data.ID;
				this.dialogHeaderText = `${cells[this.dependentTables.ZakazkaNd.cellNames?.ND_NR as number]} - ${cells[this.dependentTables.ZakazkaNd.cellNames?.TEXT as number]}`;
				this.Sleva = cells[this.dependentTables.ZakazkaNd.cellNames?.DISCOUNT_PERCENT as number];
				this.DiscountVal = cells[this.dependentTables.ZakazkaNd.cellNames?.DISCOUNT_VAL as number];
			}
		},
		async appyPartsAdditionDiscount() {
			if (this.isDiscountLimitValid(true)) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				await apiProvider.insertDiscount(this.rowDataId!, this.edit.Sleva!, this.edit.DiscountVal!);
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				this.showCancelOrderDialog = false;
				this.fetchTableData([ZAKAZKA_ND]);
				this.CenaCelkem = (await zakazkaApiProvider.getPrice(this.ZakazkaId!)).data;
			}
		},
		createClickFunc() {
			openEdit(NAME, PageMode.CREATE, {
				props: true,
				filter: { ZakazkaId: this.ZakazkaId },
			});
		},
		async onPrintVydejka() {
			this.printVydejkaNd();
		},
		editClick(event: any) {
			if (event.data.IS_LOCKED && this.dmsSys.IsCancelInvoicePrp) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemIsLocked'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (event.data.SERVICE_PACKAGE_ID !== null) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			if (this.dmsSys.IsActivityEndTimePrp && event.data.LINE_ITEM_STATUS_ID! && this.loggedUser.PracovnikData.PracovnikOzn !== UserRole.SERVICE_ADVISER) {
				showAlert({
					message: this.LocalizeChyboveHlasky('ItemCannotEidt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
				return;
			}
			openEdit(NAME, PageMode.EDIT, { props: true, id: event.data.ID });
		},
		printDialogClosed() {
			this.zakazkaNdPohybDoklId.length && (this.showTiskDialog = true);
		},
		applyDiscount() {
			if (this.isDiscountLimitValid(false)) {
				this.updateDiscount();
			} else {
				this.TotDiscPercentParts = MIN_FIELD_LEVEL;
				this.DiscountVal = MIN_FIELD_LEVEL;
			}
		},
		async updateDiscount() {
			if (this.TotDiscPercentParts! < MIN_DISCOUNT_LIMIT || this.TotDiscPercentParts! > MAX_DISCOUNT_LIMIT) {
				this.TotDiscPercentParts = MIN_FIELD_LEVEL;
				return this.showErrorAlert({
					// Using Predefined message
					message: this.LocalizeChyboveHlasky('MSGmsgDiscountShouldBe0To100'),
					options: { type: 'error' },
					localizeMessage: false,
				});
			}

			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await zakazkaApiProvider.updatePartDiscount(this.ZakazkaId, this.TotDiscPercentParts, this.DiscountVal);
			this.showDiscountSection = false;
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			this.CenaCelkem = (await zakazkaApiProvider.getPrice(this.ZakazkaId!)).data;
		},
		onApplyDiscountClick() {
			this.showDiscountSection = true;
		},
		async onCompleteMarkClick() {
			let markCompleteParts = null;
			const partsForMarkComplete = convertToObjects({ rows: this.multipleSelection, columns: this.nahradniDilyTable!.columns });
			const rowsForMarkComplete = partsForMarkComplete.map((row: any) => row);
			markCompleteParts = { Rows: rowsForMarkComplete, Options: { ZakazkaId: this.ZakazkaId } };
			if (await apiProvider.markPartsAsComplte(markCompleteParts)) {
				const { data: status } = await zakazkaApiProvider.getWorkCompletionStatus({ zakazkaId: this.ZakazkaId! });
				this.IsAllItemLevelStatusEntered = status;
				if (status) {
					await zakazkaApiProvider.sendWorkNotification({ zakaznikId: this.ZakaznikId!, zakazkaNr: this.ZakazkaNr });
				}
			}
			this.showMarkComplete = false;
			await this.fetchTableData([ZAKAZKA_ND]);
		},
		async onAdditionalMarkClick() {
			let markAdditionalParts = null;
			const partsForMarkComplete = convertToObjects({ rows: this.multipleSelection, columns: this.nahradniDilyTable!.columns });
			const rowsForMarkComplete = partsForMarkComplete.map((row: any) => row);
			markAdditionalParts = { Rows: rowsForMarkComplete, Options: { ZakazkaId: this.ZakazkaId } };
			await apiProvider.markPartsAsAdditional(markAdditionalParts);
			this.showMarkComplete = false;
			await this.fetchTableData([ZAKAZKA_ND]);
		},
		async deleteClick() {
			let canDelete: boolean = true;
			const servicePackageColId: number = this.nahradniDilyTable.cellNames!.SERVICE_PACKAGE_ID;
			const DefaultLineItemStatusIndex: number = this.nahradniDilyTable.cellNames!.LINE_ITEM_STATUS_ID;
			this.multipleSelection.map((row: any) => {
				if (row.cells[servicePackageColId] !== null) {
					canDelete = false;
					return showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				if (this.dmsSys.IsActivityEndTimePrp && row.cells[DefaultLineItemStatusIndex] === JOB_STATUS.COMPLETED) {
					canDelete = false;
					return showAlert({
						message: this.LocalizeChyboveHlasky('ItemCannotDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				return false;
			});
			if (canDelete) {
				let markdeleteParts = null;
				const partsForMarkDelete = convertToObjects({ rows: this.multipleSelection, columns: this.nahradniDilyTable!.columns });
				const rowsForMarkDelete = partsForMarkDelete.map((row: any) => row);
				markdeleteParts = { Rows: rowsForMarkDelete, Options: { ZakazkaId: this.ZakazkaId } };
				await apiProvider.markPartsAsDelete(markdeleteParts);
				this.showMarkComplete = false;
				this.showDeleteButton = false;
				await this.fetchTableData([ZAKAZKA_ND]);
			}
		},
		handleSelection(rows: any) {
			if (this.canEditTableInReleaseMode) {
				this.multipleSelection = rows.filter((x: Row) => this.partCompletionStatusCheck(x));
			} else {
				this.multipleSelection = rows;
			}
			if (this.multipleSelection.length !== 0) {
				this.showMarkComplete = true;
				if(this.NabidkaPrp!) {
                    this.showDeleteButton = true;
                }
			} else {
				this.showMarkComplete = false;
				this.showDeleteButton = false;
			}
		},
		async onDiscountChange() {
			const validRequiredData = (this.TotDiscPercentParts !== null && this.DiscountVal !== null);
			if (this.dmsSys.OrderDiscountPrp && validRequiredData) {
				if (this.VyrobekvozOzn !== VehicleBrand.SKODA) {
					this.showErrorAlert({ message: 'anyOneTypeDiscountAllowed' });
				} else if (this.VyrobekvozOzn === VehicleBrand.SKODA) {
					const isValid = await this.showConfirmPokracovat('bothDiscountMessage');
					if (!isValid) {
						this.TotDiscPercentParts = null;
						this.DiscountVal = null;
					}
				}
			}
		},
		isDiscountLimitValid(isvalidationRequired: boolean) {
			let errormsg = null;
			if (this.dmsSys.OrderDiscountPrp !== true) {
				return true;
			}
			if (this.loggedUser.DiscountLimitConfigData === null) {
				errormsg = this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} else {
				errormsg = this.validateDiscount(
					this.loggedUser.DiscountLimitConfigData.PartItemTotalPer,
				);
				if (isvalidationRequired) {
					errormsg = this.validateDiscount(
						this.loggedUser.DiscountLimitConfigData.PartItemPer,
					);
				}
			}
			if (errormsg !== null) {
				this.showErrorAlert({
					title: '',
					message: `${errormsg}${this.LocalizePopisostatni((isvalidationRequired ? 'PART_ITEM' : 'PART_ITEM_TOTAL')).toLowerCase()}.`,
					options: { type: 'error' },
					localizeMessage: false,
				});
				return false;
			}
			return true;
		},
		validateDiscount(discountper: number) {
			if (discountper === 0 || this.loggedUser.DiscountLimitConfigData === null) {
				return this.LocalizeChyboveHlasky('msgNotPerToAplyDisc');
			} if (this.TotDiscPercentParts === null) {
				return this.LocalizeChyboveHlasky('msgReqDiscOrValue');
			} if (discountper > 0 && discountper < (this.TotDiscPercentParts === null ? 0 : this.TotDiscPercentParts)) {
				return this.LocalizeAndReplace(this.LocalizeChyboveHlasky('msgNotAplyMoreThnDiscPer'), { key: '<DISC_PER>', value: `${discountper}%` });
			}
			return null;
		},

		async getSplitShareDetails(itemId: number | null) {
			this.splitShareTableloading = true;
			const response = await apiProvider.getSplitDetails(itemId, this.ZakazkaId!);
			this.splitShareTableloading = false;
			this.splitShareTable = response?.data;
		},
		canEditRow(row: Row | undefined): boolean {
			if (this.canEditTableInReleaseMode && row) {
				return this.partCompletionStatusCheck(row);
			}
			return true;
		},
		partCompletionStatusCheck(row: Row): boolean {
			return (row.cells[this.nahradniDilyTable.cellNames!.LINE_ITEM_STATUS_ID as number] !== JOB_STATUS.COMPLETED);
		},
		async onRowDiscountChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (this.dmsSys.OrderDiscountPrp !== true) {
				updateCol(value, columnId);
				row.cells[columnId] = value;
				return true;
			}

			if(this.validateRowLevelDiscount(value, updateCol, row) === false) {
				return false;
			}
		},
		async onServiceJobChange(value: string, columnId: number, updateCol: any, row: Row) {
			if (value !== null) {
			 const newServiceJobId = parseInt(value);
			 this.$store.commit(`${this.storeUri}/${START_LOADING}`);

			 if(this.zakazkaStav === ZAKAZKA_STAV.UVOLNENA && this.IsOrderSentToSaga === true && await this.isSagaSplitPartyExistInServiceJob(newServiceJobId))
			 {
				 showAlert({
						message: this.LocalizeChyboveHlasky('Service_job_with_SAGA_Split'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				  const previousServiceJobId= parseInt(row.cells[columnId]);
			  	  updateCol(previousServiceJobId, columnId);
				  row.cells[columnId] = previousServiceJobId;
				  this.$store.commit(`${this.storeUri}/${END_LOADING}`);
				  return;
			 }

				const invoiceStatus = await this.isAnyServiceJobSplitPartyInvoiced(newServiceJobId, row);
				
				if (invoiceStatus.IsServiceJobPartyInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Invoice_Generated_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsPrimaryCustomerInvoiced) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Primary_Customer_Invoiced_For_SJ_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} else if (invoiceStatus.IsServiceJobViolatingDiscountLimit) {
					showAlert({
						message: this.LocalizeChyboveHlasky('Service_Job_Violates_Discount_Limit_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					const previousServiceJobId = parseInt(row.cells[columnId]);
					updateCol(previousServiceJobId, columnId);
					row.cells[columnId] = previousServiceJobId;
				} 
				else if (this.isServiceJobSplitBillingAvailableForOrderType()) {
					updateCol(newServiceJobId, columnId);
					row.cells[columnId] = value;
				} else {
					showAlert({
						message: this.LocalizeChyboveHlasky('SJ_Split_Warning_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
				}
				if (!invoiceStatus.IsAnyDiscountPercentAndAmount){
					const discountPercentColId = this.nahradniDilyTable.cellNames!.DISCOUNT_PERCENT;
					const discountAmountColId = this.nahradniDilyTable.cellNames!.DISCOUNT_VAL;
					updateCol(0, discountPercentColId);
					updateCol(0, discountAmountColId);
					row.cells[discountPercentColId] = 0;
					row.cells[discountAmountColId] = 0;
				}
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			} else {
				updateCol(null, columnId);
				row.cells[columnId] = null;
			}
		},
		async isAnyServiceJobSplitPartyInvoiced(serviceJobId:number, row: Row) {
			const partNumberColId: number = this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID;
			const itemId = row.cells[partNumberColId];
			const discountLimitPercent = this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0;
			const { data: isInvoiced } = await apiProvider.fetchInvoiceStatusOfServiceJobParty(this.ZakazkaId, serviceJobId, itemId, PARTS, discountLimitPercent);
			return isInvoiced;
		},
		async isSagaSplitPartyExistInServiceJob(serviceJobId:number){
			const { data: isSagaSplitPartyExists } = await zakazkaApiProvider.isSagaSplitsExistInServiceJobSplit( serviceJobId, this.ZakazkaId);
			return isSagaSplitPartyExists;
		},
		isServiceJobSplitBillingAvailableForOrderType(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA && !(this.NabidkaPrp);
		},

		async isWarrantyOrGoodwillExistInServiceJobSplit(serviceJobId:number){
			const response = await apiProvider.isWarrantyOrGoodwillExistInServiceJobSplit(this.ZakazkaId!, serviceJobId);
			return response?.data;			
		},
		async isWarrantyOrGoodwillSplitExists(row:Row) {
			try {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				const partNumberColId: number = this.dependentTables.ZakazkaNd.cellNames!.ZAZNAM_ID;
				const itemId = row.cells[partNumberColId];
				const response = await apiProvider.isWarrantyOrGoodwillSplitExists(itemId,this.ZakazkaId,PARTS);
				return response?.data;
			}
			finally
			{
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		},
		validateRowLevelDiscount(value: any, updateCol: any, row: Row): boolean {			
			const discountPercentColId = this.nahradniDilyTable.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.nahradniDilyTable.cellNames!.DISCOUNT_VAL;
			const priceBeforeDiscountColId = this.nahradniDilyTable.cellNames!.PC_CEL_SL_PRED;
			const campaignDiscountColId = this.nahradniDilyTable.cellNames!.CAMPAIGN_DISCOUNT_PERCENT;
			const discountPercent = value;
			const configuredDiscountLimit = this.loggedUser.DiscountLimitConfigData?.PartItemPer ?? 0;			
			if (value === null || value === undefined || value === '') {				
				updateCol(null, discountAmountColId);
				return true;
			}
			const campaignDiscount = row.cells[campaignDiscountColId];
			const percentValue = +(_.defaultTo(discountPercent, 0));
			const totalDiscountPercent = +(_.defaultTo(discountPercent, 0)) + +(_.defaultTo(campaignDiscount, 0));
			if (totalDiscountPercent < 0 || totalDiscountPercent > 100) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_INVALID') });
				updateCol(null, discountPercentColId);
				//updateCol(null, discountAmountColId);
				return false;
			}

			if (configuredDiscountLimit !== undefined && configuredDiscountLimit !== null && totalDiscountPercent > configuredDiscountLimit) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_PERCENT_EXCEEDS_LIMIT') });
				updateCol(null, discountPercentColId);
				//updateCol(null, discountAmountColId);
				return false;
			}

			updateCol(percentValue, discountPercentColId);
			// When discount percent is entered, clear discount amount to ensure only one value is used
			if (percentValue >= 0) {
				updateCol(null, discountAmountColId);
			}
			
			//updateCol(null, discountAmountColId);
			// const priceBeforeDiscount = +(_.defaultTo(row.cells[priceBeforeDiscountColId], 0));

			// if (Number.isNaN(percentValue) || percentValue < 0 || percentValue > 100 || priceBeforeDiscount <= 0) {
			// 	//updateCol(null, discountAmountColId);
			// 	return false;
			// }

			// const calculatedDiscountAmount = +((priceBeforeDiscount * totalDiscountPercent) / 100).toFixed(2);
			// updateCol(calculatedDiscountAmount, discountAmountColId);
			return true;
		},

		onRowDiscountAmountLeave(value: any, row: Row, columnId: number, updateCol: any): Boolean {
			console.log(`onRowDiscountAmountLeave called at ${new Date().toISOString()}`);
			const discountPercentColId = this.nahradniDilyTable.cellNames!.DISCOUNT_PERCENT;
			const discountAmountColId = this.nahradniDilyTable.cellNames!.DISCOUNT_VAL;
			const unitPriceColId = this.nahradniDilyTable.cellNames!.RRP_UNIT_PRICE;
			const quantityColId = this.nahradniDilyTable.cellNames!.X_STAVVJ;
			const campaignDiscountColId = this.nahradniDilyTable.cellNames!.CAMPAIGN_DISCOUNT_PERCENT;
			const discountAmount = value;
			const campaignDiscount = +(_.defaultTo(row.cells[campaignDiscountColId], 0));
			if (discountAmount === undefined) {
				updateCol(null, discountPercentColId);
				return true;
			}
			if (discountAmount === null || discountAmount === undefined || discountAmount === '') {		
				updateCol(null, discountPercentColId);
				return false;
			}

			const amountValue = +discountAmount;
			if (Number.isNaN(amountValue) || amountValue < 0) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('SB_DISCOUNT_AMOUNT_INVALID') });
				updateCol(null, discountAmountColId);
				return false;
			}

			const itemId: number = +(row.cells[this.nahradniDilyTable.cellNames!.ZAZNAM_ID] ?? 0);
			if (itemId <= 0) {
				const originalPrice = +(row.cells[unitPriceColId] ?? 0) * +(row.cells[quantityColId] ?? 1);
				if (amountValue > originalPrice) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DiscountCannotBeLarger') });
					updateCol(null, discountAmountColId);
					return false;
				}
			}
			updateCol(amountValue, discountAmountColId);
			// When discount amount is entered, clear discount percent to ensure only one value is used
			if (amountValue >= 0) {
				updateCol(null, discountPercentColId);
			}
			return true;
		},

		
	},
});
